			$(function () {
			    const swiper1 = new Swiper(".swiper-container.swiper_sct5", {
			    loop: true, // ループ
			    slidesPerView: 2.8, // 一度に表示する枚数
			    spaceBetween: 40,
          centeredSlides: true,
			    speed: 1000, // ループの時間
			    autoplay: {
			      //自動再生
			      delay: 5000, // 途切れなくループ
			    },
			      pagination: {
			        el: '.swiper-pagination',
			        type: 'bullets',
			        clickable: true,
			      },
			      breakpoints:{
			        768:{
			          slidesPerView: 2.2, // 一度に表示する枚数
			        },
			        300:{
			          slidesPerView: 1, // 一度に表示する枚数
			          spaceBetween: 50,
			          centeredSlides: true,
			        }
			      },
			    });
			});